/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum PreparationStatutCommandes {
  EnAttente = 'EnAttente',
  APreparer = 'APreparer',
  EnPreparation = 'EnPreparation',
  Preparee = 'Preparee',
  Livree = 'Livree',
}
